module.exports = __webpack_public_path__ + "img/icon-facebook.35438c0a.svg";